// prefer default export if available
const preferDefault = m => m && m.default || m

exports.components = {
  "component---src-templates-noterush-leaderboard-js": () => import("/Users/lukepurton/dev/ella/src/templates/noterush-leaderboard.js" /* webpackChunkName: "component---src-templates-noterush-leaderboard-js" */),
  "component---src-pages-404-js": () => import("/Users/lukepurton/dev/ella/src/pages/404.js" /* webpackChunkName: "component---src-pages-404-js" */),
  "component---src-pages-index-js": () => import("/Users/lukepurton/dev/ella/src/pages/index.js" /* webpackChunkName: "component---src-pages-index-js" */)
}

exports.data = () => import(/* webpackChunkName: "pages-manifest" */ "/Users/lukepurton/dev/ella/.cache/data.json")

